<template>
  <div class="portlet-body form">
    <form class="form-horizontal" role="form">
      <div class="form-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="col-md-2 control-label">{{ trans('overproduction.select_type_of_date') }}:</label>
              <single-select
                  v-model="selectedDeliveryType"
                  name="deliveryType"
                  class="col-md-5"
                  :options="deliveryTypes"
                  :checked="selectedDeliveryType"
                  label="value"
                  @dispatch="$emit('disableSaveButtons', false)"
                  @change="changeDeliveryType"
                  :allow-empty="false"
              />
              <div class="col-md-5">
                <date-picker
                    v-model="formDate"
                    :time="false"
                    :is-nullable="false"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="col-md-2 control-label">Marka sprzedażowa:</label>
              <div class="col-md-4">
                <multi-select
                    v-model="formSellBrands"
                    :options="sellBrands"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="col-md-2 control-label">Marka produkcyjna:</label>
              <div class="col-md-4">
                <multi-select
                    v-model="formProductionBrands"
                    :options="productionBrands"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button
                type="button"
                class="btn btn-primary"
                @click="search">
              {{ trans('common.show') }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Checkbox from '@component/dccore-form/checkbox.vue'
import DatePicker from '@component/datePicker.vue'
import MultiSelect from '@component/multiselect.vue'
import axios from 'axios'
import SingleSelect from '@component/singleselect.vue'
import {DELIVERY_TYPES} from '../../../const/common.js'

export default {
  name: 'OverproductionSearch',
  components: {
    DatePicker,
    MultiSelect,
    SingleSelect,
    Checkbox,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    disableSaveButtons: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      deliveryTypes: DELIVERY_TYPES,
      sellBrands: [],
      productionBrands: [],
      formDate: this.date,
      formSellBrands: [],
      formProductionBrands: [],
      selectedDeliveryType: 'delivery_date'
    }
  },
  watch: {
    formSellBrands(value) {
      this.$emit('disableSaveButtons', false)
      this.$emit('getBrands', {'sellBrands': this.formSellBrands, 'productionBrands': this.formProductionBrands})
    },
    formProductionBrands(value) {
      this.$emit('disableSaveButtons', false)
      this.$emit('getBrands', {'sellBrands': this.formSellBrands, 'productionBrands': this.formProductionBrands})
    },
    formDate() {
      this.$emit('disableSaveButtons', false)
      this.$emit('getFormDate', this.formDate)
    },
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    changeDeliveryType(value) {
      this.$emit('getDeliveryType', value)
    },
    search() {
      const overproductionSearchParams = {
        queryStringParams: {
          dateType: this.selectedDeliveryType,
          sellBrands: this.formSellBrands,
          productionBrands: this.formProductionBrands,
        },
        queryParams: {
          date: this.formDate
        }
      }

      this.$emit('searchOverproduction', overproductionSearchParams)
    },
    getBrands() {
      this.$emit('request')
      const url = Routing.generate('api_get_brands', { context: 'dropdown' })

      axios.get(url).then(response => {
        for (const brand of response.data) {
          if (brand['isSale']) {
            this.sellBrands.push(brand);
          }
          if (brand['isProduction']) {
            this.productionBrands.push(brand);
          }
        }
      }, response => {
        this.handleAjaxError(response)
      })
    }
  }
}
</script>
